import React, { useEffect, useState } from "react";
import { Button, Spinner, Modal, Form as BsForm } from "react-bootstrap";
import { ErrorMessage, Field, Formik, Form as FormikForm } from "formik";

import { createResources, createTermsConditions, deleteTermsConditions, getResources, getTermsConditions, updateTermsConditions } from "../../services/Admin/adminServices";
 
import toast from "react-hot-toast";
import RichTextEditor from "../components/Common/RichTextEditor";
import * as Yup from "yup";
const Terms = () => {
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
 const [selectedInfo, setSelectedInfo] = useState(null);
  const [showAdd, setShowAdd] = useState(false);
  const fetchData = async () => {
    try {
      const response = await getTermsConditions();

      setInfo(response?.data?.data);
    } catch (error) {
      console.error("Error fetching documentation info:", error);
    } finally {
      setLoading(false);
    }
  };


  
  useEffect(() => {
    fetchData();
  }, []);

  const handleUpdate = async (values) => {
    try {
      await updateTermsConditions(values); // call update API
      toast.success("updated")
     fetchData();
      setShowModal(false);
    } catch (err) {
      console.error("Update failed:", err);
      toast.error(err?.response?.data?.message)
    }
  };

   const handleEditClick = (info) => {
    setSelectedInfo(info);
    setShowModal(true);
  };
   const handleAdd = () => {
    setShowAdd(true);
    
  };
    const handleDelte = async (id) => {
      try {
        await deleteTermsConditions(id);
        fetchData();
        toast.success("Deleted SuccessFully");
      } catch (error) {
        console.error("Delete error:", error);
      }
    };
  
 
  return (
    <div className=" ">
      <div className="d-flex justify-content-between mb-3">
        <h2 className="mb-3" style={{color:"#0AB7EA"}}>Terms & Conditions  </h2>
        <div>
          {/* <button
            className="btn"
            style={{
              backgroundColor: "#0AB7EA",
              color: "white",
              border: "none",
              padding: "8px 16px",
              borderRadius: "4px",
            }}
          onClick={()=>handleAdd()}
          >
            Add new
          </button> */}
        </div>
      </div>

      {loading ? (
        <div className="d-flex justify-content-center my-5">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : !info ? (
        <p>No Terms and condition   available.</p>
      ) : (
        <ul>
          <ul className="list-group">
            {info?.map((item) => (
              <li
                key={item._id}
                className="list-group-item d-flex justify-content-between flex-column"
                style={{ borderColor: "#0AB7EA" }}
              >
            

                  
              <div className="d-flex justify-content-between w-100 " > 
                  <h2 className="fw-bold  mb-1"   >  {item.title}</h2>
                 <div className="d-flex gap-2" >   

                   <button
                  className="btn  responsive-btn"
                  style={{
                    backgroundColor: "#0AB7EA",
                    color: "white",
                    border: "none",
                  }}
                      onClick={() => handleEditClick(item)}
                >
                  Edit
                </button>
                 {/* <button
                  className="btn btn-sm"
                  style={{
                    backgroundColor: "red",
                    color: "white",
                    border: "none",
                  }}
                      onClick={() => handleDelte(item._id)}
                >
                  Delete
                </button> */}
                </div></div>
                   <div    className="desc-text" dangerouslySetInnerHTML={{ __html: item.description }} />
             
               
              </li>
            ))}
          </ul>
        </ul>
      )}

      {/* Edit Modal */}
    {selectedInfo&&(  <Modal show={showModal} onHide={() => setShowModal(false)} dialogClassName="rich-editor-modal">
        <Modal.Header closeButton>
          <Modal.Title className="titleColor">Edit Terms & Conditions</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={{
            title: selectedInfo?.title || "",
            description: selectedInfo?.description || "",
            termsConditionId: selectedInfo?._id || "",
          }}
          enableReinitialize
          onSubmit={handleUpdate}
        >
          {({ handleChange, handleSubmit, values,setFieldValue }) => (
            <BsForm onSubmit={handleSubmit}>
              <Modal.Body>
                <BsForm.Group className="mb-3">
                  <BsForm.Label>Title</BsForm.Label>
                  <BsForm.Control
                    type="text"
                    name="title"
                    value={values.title}
                    onChange={handleChange}
                  />
                </BsForm.Group>
                  <div className="mb-3">
                              <label className="form-label">Description</label>
                              
                                <RichTextEditor
                      value={values.description}
                      onChange={(content) => setFieldValue("description", content)}
                      placeholder="Write the terms description..."
                    />
                    <ErrorMessage name="description" component="div" className="text-danger" />
                            </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowModal(false)}>
                  Cancel
                </Button>
                <Button type="submit" style={{ backgroundColor: "#0AB7EA", border: "none" }}>
                  Save Changes
                </Button>
              </Modal.Footer>
            </BsForm>
          )}
        </Formik>
      </Modal>)}









        <Modal show={showAdd} onHide={() => setShowAdd(false)} dialogClassName="rich-editor-modal">
              <Modal.Header closeButton>
                <Modal.Title>Add Terms And Conditions  </Modal.Title>
              </Modal.Header>
              <Formik
                initialValues={{
                 
                    title: "",
                  description:"",
                }}
                enableReinitialize
                validationSchema={Yup.object({
                  description: Yup.string().required("Description is required"),
                })}
                onSubmit={async(values) => {
                try {
 
       const payload = { ...values };
    if (!payload.title || payload.title.trim() === "") {
      delete payload.title;
    }
 
      const res = await createTermsConditions(payload);
fetchData()
       toast.success("Added")
   
      setShowAdd(false);
    } catch (error) {
 
toast.error(error?.response?.data?.message)
      console.error("error", error.response.data.message);
    }
             
                }}
              >
                {({ isSubmitting ,values,setFieldValue }) => (
                  <FormikForm>
            
                    <Modal.Body>
                      <div className="mb-3">
                                <label htmlFor="title" className="form-label">
                    Title
                        </label>
                        <Field
                     
                          name="title"
                          id="title"
                        
                          className="form-control"
                          style={{ borderColor: "#0AB7EA" }}
                        />
                        <ErrorMessage
                          name="title"
                          component="div"
                          className="text-danger"
                        />
       <label className="form-label">Description</label>
                            
                                <RichTextEditor
                      value={values.description}
                      onChange={(content) => setFieldValue("description", content)}
                      placeholder="Write the terms description..."
                    />
                    <ErrorMessage name="description" component="div" className="text-danger" />
                   
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={() => setShowAdd(false)}>
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        style={{ backgroundColor: "#0AB7EA", border: "none" }}
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? "Uploading" : "Save Changes"}
                      </Button>
                    </Modal.Footer>
                  </FormikForm>
                )}
              </Formik>
            </Modal>
    </div>
  );
};

export default Terms;
